import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/topics';

export default function TopicsSection() {
  const featured = topics[0];
  const rest = topics.slice(1, 5);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          eyebrow="Latest Posts"
          title="最新爆料推荐"
          desc="编辑每日挑选值得一读的整理与复盘，标注信息来源与可信度区间，方便你自行判断。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          查看全部话题
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-6">
          <article className="h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col">
            <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src={featured.image}
                alt={`${featured.title}配图`}
                title={`${featured.title} · 爆料专区`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium whitespace-nowrap">
                编辑精选
              </span>
            </div>
            <div className="p-6 md:p-7 flex-1 flex flex-col">
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800">{featured.categoryName}</span>
                <span>{featured.date}</span>
                <span>· {featured.reading}</span>
              </div>
              <h3 className="font-heading mt-4 text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{featured.summary}</p>
              <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                <span className="text-xs text-foreground-500">{featured.author}</span>
                <span className="inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap">
                  <i className="ri-fire-line" />
                  {featured.hot.toLocaleString()} 热度
                </span>
              </div>
            </div>
          </article>
        </Reveal>

        <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {rest.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 50}>
              <article className="h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col">
                <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                  <img
                    src={topic.image}
                    alt={`${topic.title}配图`}
                    title={`${topic.title} · 爆料专区`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <span className="text-xs text-secondary-700 font-medium">{topic.categoryName}</span>
                  <h3 className="font-heading mt-2 text-base font-semibold text-foreground-950 leading-snug">
                    {topic.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2 flex-1">
                    {topic.summary}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                    <span>{topic.date}</span>
                    <span>{topic.reading}</span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}